import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: fulfillmentUrl('inventory'),
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_inventory.js